import axios from "axios";
import config from "../config/env";

const axiosApi = axios.create({
  baseURL: config.API_URL,
});

// This will be set by the component using the API
let authToken = null;

// Function to set the auth token from react-oidc-context
export const setAuthToken = (token) => {
  authToken = token;
};

// Set up request interceptor to add token to each request
axiosApi.interceptors.request.use(
  config => {
    try {
      if (authToken) {
        config.headers["Authorization"] = `Bearer ${authToken}`;
      }
      config.headers["Content-Type"] = "application/json";
      return config;
    } catch (error) {
      console.error("Error setting auth token:", error);
      return config;
    }
  },
  error => Promise.reject(error)
);

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  try {
    const response = await axiosApi.put(url, data, { ...config });
    return response.data;
  } catch (error) {
    console.error("PUT request error:", error.response || error);
    throw error;
  }
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
